import { POST_USER_FAILURE, POST_USER_REQUEST, POST_USER_SUCCESS, PostUserActionTypes, PostUserState } from './types';

const defaultState: PostUserState = {
  isLoading: false,
  errorMessage: "",
};

export default function postUser(state = defaultState, action: PostUserActionTypes): PostUserState {
  switch (action.type) {
    case POST_USER_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case POST_USER_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case POST_USER_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};
